import React from "react";
import TextArea from "../../../../widget/common/form/Textarea";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { MyMessagesContextImport } from "../../../../provider/work_profile/my_messages/MyMessagesContextProvider";
import Input from "../../../../widget/common/form/Input";

export const MyMessagesTitleField = () => {
  const { titleField, handleOnChange, submitForm, fieldsValid } =
    MyMessagesContextImport();

  return (
    <Input
      type="text"
      name="title"
      handleOnChange={handleOnChange}
      value={titleField}
      validate={true}
      label="title"
      error={submitForm ? !fieldsValid.title : false}
    />
  );
};

export const MyMessagesMessageField = () => {
  const { messageField, handleOnChange, maxWords, submitForm, fieldsValid } =
    MyMessagesContextImport();

  return (
    <>
      <TextBlock
        fontName="book"
        fontSize="13_14"
        textColor="theme-label"
        className="px-2 pt-3"
      >
        {AppTranslation.text("message")}
      </TextBlock>
      <TextArea
        name="message"
        rowSize={8}
        maxWords={maxWords}
        placeHolder={AppTranslation.text("type_here_max_200_chars")}
        handleOnChange={handleOnChange}
        value={messageField}
        validate={true}
        error={submitForm ? !fieldsValid.message : false}
      />
    </>
  );
};
